const Report = () =>
  import(
    /* webpackChunkName: "order-temporary" */ '@/pages/order/temporary/index.vue'
  )

export default {
  path: 'temporary',
  meta: {
    label: 'temporaryShipment',
    auth: 'temporary'
  },
  component: {
    name: 'Temporary',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'OrderTemporaryReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    }
  ]
}
